<template>
  <v-row no-gutters style="background-color: #0f0f0f; min-height: 100vh">
    <v-col cols="12" class="pa-4 pa-sm-8">
      <div class="mb-6 px-2">
        <h1 class="text-h4 white--text font-weight-black transition-all">
          {{ tituloDinamico }}
        </h1>
      </div>

      <v-tabs
        v-model="currentItem"
        background-color="transparent"
        dark
        slider-color="white"
        class="yt-tabs-main mb-0"
      >
        <v-tab :to="{ name: 'empresa.sucursal.productos' }" class="text-none">
          Productos
        </v-tab>
        <v-tab :to="{ name: 'empresa.sucursal.productos.inventario' }" class="text-none">
          Inventario
        </v-tab>
      </v-tabs>
      <v-divider class="grey darken-4"></v-divider>

      <div class="d-flex align-center py-2 px-2 border-bottom-subtle">
        
        <div class="flex-grow-1 d-flex align-center">
          <producto-buscador
            :key="reload_search"
            :usarProductoEmpresa="false"
            @process-buscador-producto="goToBuscador"
            @process-buscador-producto-select="goToBuscador"
          />
          
          <v-divider vertical class="mx-4 my-2 grey darken-3" style="height: 20px"></v-divider>
          
          <div >
            <ProductosSucursalFiltros :withTags="false" />
          </div>
        </div>
      </div>

      <div class="mt-6">
        <v-fade-transition mode="out-in">
          <router-view  />
        </v-fade-transition>
      </div>

    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";
import ProductosSucursalFiltros from "@/components/producto/filtros/ProductosSucursalFiltros.vue";

export default {
  name: "SucursalProductosHome",
  components: {
    ProductoBuscador,
    ProductosSucursalFiltros,
  },
  data() {
    return {
      currentItem: "",
      reload_search: 1,
    };
  },
  computed: {
    ...mapState("productos", ["paginacion_productos_admin", "productos_admin"]),
    // El título cambia según el tab seleccionado
    tituloDinamico() {
      return this.$route.name.includes('inventario') 
        ? 'Inventario de la sucursal' 
        : 'Productos de la sucursal';
    }
  },
  methods: {
    ...mapActions("productos", []),
    ...mapMutations("productos", ["set_page_productos_admin"]),

    get_text_transform(str) {
      return typeof str === "string" ? str.match(/[^ ]+/g).join("-") : str;
    },

    add_query_url(value) {
      var querys = Object.assign({}, this.$route.query);
      for (const property in value) {
        querys[property] = this.get_text_transform(value[property]);
      }
      this.$router.replace({ query: querys }).catch((error) => {
        if (error.name !== "NavigationDuplicated") throw error;
      });
    },

    goToBuscador(search) {
      if (search == this.$route.query.q) return;
      this.set_page_productos_admin(1);

      let isnum = /^\d+$/.test(search);
      if (isnum && search.length > 6) {
        this.add_query_url({ barcode: search });
      } else {
        this.add_query_url({ q: search });
      }
    },
  },
};
</script>

<style scoped>
.transition-all { transition: all 0.3s ease; }

/* Tabs: Estilo exacto a la captura de YouTube */
.yt-tabs-main >>> .v-tab {
  font-size: 14px;
  font-weight: 700;
  color: #aaa !important;
  text-transform: none;
  letter-spacing: normal;
  padding: 0 16px;
  min-width: 80px;
}
.yt-tabs-main >>> .v-tab--active {
  color: white !important;
}
.yt-tabs-main >>> .v-tabs-slider {
  height: 3px !important;
}

/* Filtros minimalistas */
.border-bottom-subtle {
  border-bottom: 1px solid #222;
}

/* Resetear el buscador para que parezca solo texto de "Filtrar" */
.yt-minimal-search >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
}
.yt-minimal-search >>> input {
  color: #888 !important;
  font-size: 14px;
}
.yt-minimal-search >>> input::placeholder {
  color: #555 !important;
}

/* Filtros de sucursal compactos */
.yt-minimal-filters >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  font-size: 13px;
}
</style>